import React from 'react';
import PropTypes from 'prop-types';
import { ArrowDownIcon } from '@edusynch/edusynch-svg-icons';
import * as S from './styles';

const InputCustom = ({ children, className, ...props }) => (
  <S.Container className={className}>
    {children}
    <S.InputField {...props} />
    <ArrowDownIcon color="#5D6670" />
  </S.Container>
);

InputCustom.propTypes = {
  className: PropTypes.string,
  children: PropTypes.element,
};

export { InputCustom };
